import {Component, Input, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'esp-multi-select-item',
  templateUrl: './multi-select-item.component.html',
  styleUrls: ['./multi-select-item.component.css']
})
export class MultiSelectItemComponent implements OnInit {

  @Input() item;

  constructor() { }

  ngOnInit(): void {
  }

}
